import { useContext } from 'react';
import { parseISO } from 'date-fns';
import { localizationContext } from './localizationContext';
import { Translate } from './Translate';
import { EditTranslate } from './editTranslate/EditTranslate';
import { jsx as _jsx } from "react/jsx-runtime";
export var useLocalizationContext = function useLocalizationContext() {
  var context = useContext(localizationContext);
  if (!context) {
    throw new Error('imLocalizationContext value is undefined. Make sure you use the ImLocalizationProvider before using the context.');
  }
  return context;
};
export var useLocalization = function useLocalization() {
  var context = useLocalizationContext();
  var formatDate = function formatDate(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'short';
    if (!date) {
      return '';
    }
    var dateToFormat = typeof date === 'string' ? parseISO(date) : date;
    return context.localizationService.formatDate(dateToFormat, {
      dateFormat: format
    });
  };
  var formatCurrency = function formatCurrency(amount, currencyCode) {
    return currencyCode ? context.localizationService.formatCurrencyByCode(amount, currencyCode) : context.localizationService.formatCurrency(amount);
  };
  var formatToShortCurrency = function formatToShortCurrency(amount, currencyCode) {
    return currencyCode ? context.localizationService.formatToShortCurrencyByCode(amount, currencyCode) : context.localizationService.formatToShortCurrency(amount);
  };
  var translate = function translate(key, params, paramsWithDangerousHtml) {
    return context.isEditingEnabled ? /*#__PURE__*/_jsx(EditTranslate, {
      params: params,
      paramsWithDangerousHtml: paramsWithDangerousHtml,
      text: key
    }) : /*#__PURE__*/_jsx(Translate, {
      params: params,
      paramsWithDangerousHtml: paramsWithDangerousHtml,
      text: key
    });
  };
  return {
    formatCurrency: formatCurrency,
    formatDate: formatDate,
    formatToShortCurrency: formatToShortCurrency,
    translate: translate
  };
};